import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const ns = 'entities';
export const keyPrefix = 'sources.stream_settings';
export const useStreamSettingsTranslation = (): UseTranslationResponse<
  typeof ns,
  typeof keyPrefix
> => useTranslation(ns, { keyPrefix });
